import { CircularProgress } from '@mui/material';
import { FC } from 'react';

import { RootContainer } from './styles';
import { Props } from './types';

const Loading: FC<Props> = ({ className, containerMode, size = 20 }) =>
  containerMode ? (
    <RootContainer size={size} className={className} />
  ) : (
    <CircularProgress className={className} size={size} />
  );

export default Loading;
